// disable strong password validation in development mode
import * as Yup from 'yup'

const popularPasswords = [
    '123456',
    'password',
    '123456789',
    '12345678',
    'qwerty',
    '1234567',
    '111111',
    '1234567890',
    '123123',
    'abc123',
    'password1',
    'iloveyou',
    '1q2w3e4r',
    '000000',
    'qwerty123',
    'zaq12wsx',
    'dragon',
    'sunshine',
    'princess',
    'letmein',
    '654321',
    'monkey',
    '1qaz2wsx',
    '123321',
    'qwerty',
    'qwertyuiop',
    'superman',
    'asdfghjkl'
]

const passwdValidator =
    process.env.NODE_ENV === 'development'
        ? Yup.string().required('Password is required').min(4, 'Password must be at least 4 characters')
        : Yup.string()
              .required('Password is required')
              .min(6, 'Password must be at least 6 characters')
              .notOneOf(popularPasswords, 'Password is too common')
              .test('Same as nick', "Password can't be same as nick", function (value): boolean {
                  return this.parent.nick !== value
              })

export default passwdValidator
